import dayjs from "dayjs";
import ButtonSymphony from "../../elements/ButtonSymphony";
import { CSSProperties } from "react";
import Sty from "modules/Sty";
import Loader from "elements/Loader";

var decodeEntities = (function () {
    // this prevents any overhead from creating the object each time
    var element = document.createElement('div');

    function decodeHTMLEntities(str: string) {
        var string: any = str
        if (str && typeof str === 'string') {
            // strip script/html tags
            str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
            str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
            element.innerHTML = str;
            string = element.textContent;
            element.textContent = '';
        }

        return string;
    }

    return decodeHTMLEntities;
})();

interface RecordSelectorProps {
    content: Array<any>,
    onVideoSelected: (videoDetails: any) => void;
    filter?: string;
    searchString?: string;
    loadingSearch: boolean;
    connectYoutubeButton: any;
    youtubeConnected: boolean;
}

const VideoSelector = (props: RecordSelectorProps) => {
    const {
        content,
        onVideoSelected,
        filter,
        searchString = '',
        loadingSearch,
        connectYoutubeButton,
        youtubeConnected = false
    } = props

    const renderSearchLoader = () => {
        if (!loadingSearch) {
            return null
        }

        return (
            <div className="searchLoader" style={sty.searchLoader}>
                <Loader height={48} width={48} />
                <p className="mt-1">Searching...</p>
            </div>
        )
    }

    const renderVideoCard = (videoItem: any, idx: number) => {
        const {
            id: videoId,
            channelId,
            channelTitle,
            description,
            publishedAt,
            thumbnails,
            title: videoTitle
        } = videoItem

        const primaryThumbnail = thumbnails.default ? thumbnails.default.url :
            thumbnails.high ? thumbnails.high.url : null

        const decodedTitle = decodeEntities(videoTitle)

        const handleVideoSelect = () => {
            const videoDetails = {
                ...videoItem,
                primaryThumbnail,
                name: decodedTitle,
                url: searchString
            }

            onVideoSelected(videoDetails)
        }

        return (
            <div
                key={`${videoId}-${idx}`}
                className="videoSelectorCard"
                style={sty.videoSelectorCard}
            >
                <img
                    className="thumbnail"
                    style={sty.thumbnail}
                    src={primaryThumbnail}
                    alt="YouTube Thumbnail"
                />
                <div
                    className="contentWrapper"
                    style={sty.contentWrapper}
                    onClick={handleVideoSelect}
                >
                    <div className="videoSelectorTitle" style={Sty.text16bold}>
                        {decodedTitle}
                    </div>
                    <div className="videoSelectorChannelRow flex items-center">
                        <img
                            className="videoSelectorYoutubeLogo h-full w-auto"
                            src={require('../../assets/images/streaming/icons/youtube-logo.svg').default}
                            alt="YouTube Logo"
                        />
                        <p
                            className="videoSelectorChannelText"
                            style={sty.channelText}
                        >
                            Channel: {channelTitle}
                        </p>
                    </div>
                    <div
                        className="videoSelectorReleaseDate"
                        style={sty.releaseDate}
                    >
                        Release Date: {dayjs(publishedAt).format('M/DD/YYYY')}
                    </div>
                </div>
                <ButtonSymphony
                    className="selectVideoButtonVideoSelector"
                    onClick={handleVideoSelect}
                    style={{ marginLeft: 'auto' }}
                    variant="text"
                >
                    Select
                </ButtonSymphony>
            </div>
        )
    }

    const renderVideoList = () => {
        if (!content || content?.length === 0) {
            return null
        }

        return content
            .sort((a, b) => new Date(b.publishedAt).valueOf() - new Date(a.publishedAt).valueOf())
            .map(renderVideoCard)
    }

    const shouldShowContent = () => {
        if ((!searchString || searchString === '') && content.length === 0 && !youtubeConnected) {
            return false
        }
        return true
    }

    if (!shouldShowContent()) {
        return null
    }

    return (
        <div className="videoSelectorComponent" style={sty.videoSelectorComponent}>
            {renderSearchLoader()}
            {renderVideoList()}
        </div>
    )
}

const sty: Record<string, CSSProperties> = {
    videoSelectorComponent: {
        display: 'flex',
        flexDirection: 'column',
        boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.15)',
        borderRadius: 8,
        maxHeight: 400,
        overflowY: 'auto'
    },
    searchLoader: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: 32
    },
    videoSelectorCard: {
        display: 'flex',
        flexDirection: 'row',
        cursor: 'pointer',
        gap: 8,
        borderBottom: Sty.border,
        padding: 16
    },
    thumbnail: {
        flexShrink: 0,
        borderRadius: 8,
        width: 80
    },
    contentWrapper: {
        padding: '0 12px'
    },
    channelIcon: {
        height: 20,
        width: 'auto',
        margin: '2px 0'
    },
    channelText: {
        fontSize: 14,
        marginLeft: 4
    },
    releaseDate: {
        fontSize: 12
    },
    rightArrow: {
        margin: 16
    }
}

export default VideoSelector